module.exports = __webpack_public_path__ + "img/kuraray_PPT1_JP.06e77227.jpg";